import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** True when every selected object has its own `frozen` flag (freeze switch on). */
export function selectionFrozenChecked(shapes: ShapeData[]): boolean {
  if (shapes.length === 0) return false

  return shapes.every((shape) => shape.frozen === true)
}

/** True when every selected object has its own `locked` flag (lock switch on). */
export function selectionLockedChecked(shapes: ShapeData[]): boolean {
  if (shapes.length === 0) return false

  return shapes.every((shape) => shape.locked === true)
}

/** True when every selected object has its own `ignoreTextWrap` flag ("Ignore wrap" switch on).
 *  Any shape or text frame can carry this field (see the Object panel's Ignore Wrap section). */
export function selectionIgnoreTextWrapChecked(shapes: ShapeData[]): boolean {
  if (shapes.length === 0) return false

  return shapes.every((shape) => shape.ignoreTextWrap === true)
}

/** True when 2+ selected objects disagree on `ignoreTextWrap` — the "Mixed" indeterminate
 *  display, never a third persisted value (see the Object panel's Ignore Wrap section). */
export function selectionIgnoreTextWrapMixed(shapes: ShapeData[]): boolean {
  if (shapes.length < 2) return false
  const first = shapes[0].ignoreTextWrap === true

  return shapes.some((shape) => (shape.ignoreTextWrap === true) !== first)
}
